import { pipe } from 'fp-ts/lib/function';
import { failure, literal, parse, success, union } from 'io-ts/Decoder';

import { isUUID } from '@bedc/core';

import { Id as PlatformUserId } from '../user/Id';

/**
 * A user id as report filters accept it: a `user:` id that is a UUID or one of
 * the platform's slug-style users (`user:system`, `user:masked-bedc-owner`,
 * `user:me`, …), or the warehouse's `unassigned` sentinel — the reporting MVs
 * store a missing assignee as that literal (`NVL(collaborator_id, 'unassigned')`),
 * so the assignee filter sends it back as a value.
 */
const slug = /^[a-z0-9][a-z0-9-]{0,63}$/;

const PlatformUserIdWithShape = pipe(
	PlatformUserId,
	parse((id) => {
		const rest = id.slice('user:'.length);
		return isUUID(rest) || slug.test(rest) ? success(id) : failure(id, 'a user id');
	})
);

export const UserId = union(literal('unassigned'), PlatformUserIdWithShape);
